import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CreateSuggestion, SuggestionInformation } from "src/app/domain/models/ExportOfferSuggestion";

@Injectable({providedIn: 'root'})
export abstract class SuggestionGateway {
  abstract create(request: CreateSuggestion): Observable<SuggestionInformation>
}
